/** The social platforms a creator can share their code on. */
export const CREATOR_PLATFORMS = [
	'instagram',
	'youtube',
	'x',
	'snapchat',
	'whatsapp',
	'telegram',
] as const;
export type CreatorPlatform = (typeof CREATOR_PLATFORMS)[number];

export const PLATFORM_LABELS: Record<CreatorPlatform, string> = {
	instagram: 'Instagram',
	youtube: 'YouTube',
	x: 'X',
	snapchat: 'Snapchat',
	whatsapp: 'WhatsApp',
	telegram: 'Telegram',
};

export const PROFILE_URL_PLACEHOLDERS: Record<CreatorPlatform, string> = {
	instagram: 'instagram.com/yourhandle',
	youtube: 'youtube.com/@yourchannel',
	x: 'x.com/yourhandle',
	snapchat: 'snapchat.com/add/yourhandle',
	whatsapp: 'whatsapp.com/channel/…',
	telegram: 't.me/yourchannel',
};
